import React from 'react';
import PropTypes from 'prop-types';
import { StyledTable } from './style';

const Table = ({ children, ...props }) => (
  <StyledTable {...props}>{children}</StyledTable>
);

Table.propTypes = {
  children: PropTypes.node.isRequired
};

export default Table;
